<template>
  <div class="row">
    <div class="col-md-12">
      <!-- <vuestic-widget class="no-padding no-v-padding"> -->
        <div class='vuestic-breadcrumbs'>
          <!-- <router-link :to="'/dashboard'" class="crumb">Dashboard</router-link> -->
          <div v-for="(item, index) in breadcrumbs" class="crumb">
            <div class="nav-item dropdown navbar-dropdown d-flex align-items-center" v-dropdown v-if="item.meta.title === current">
              <a class="nav-link dropdown-toggle d-flex align-items-center justify-content" href="#"
                 @click.prevent="closeMenu">
                {{ current }}
              </a>
              <div class="dropdown-menu last">
                <div class="dropdown-menu-content">
                  <div class="dropdown-item plain-link-item" v-for="item in items" :class="{ 'active': item.meta.title === current }">
                    <router-link :to="{ name: item.name }">
                      {{ item.meta.title }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <router-link v-else
              :to="{path: item.path}"
              :key="index"
              v-bind:class="{ disabled: !item.path || item.meta.breadcrumbDisabled }"
            >
              {{item.meta.title | translate}}
            </router-link>
          </div>
        </div>
      <!-- </vuestic-widget> -->
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'
  export default {
    name: 'vuestic-breadcrumbs',
    props: {
      breadcrumbs: {
        type: Array,
        default: []
      },
      items: {
        type: Array,
        default: []
      }
    },
    data: function () {
      return {
      }
    },
    computed: {
      current () {
        return this.$route.meta.parent || this.$route.meta.title
      }
    },
    methods: {
      ...mapActions([
        'closeMenu'
      ])
    }
  }
</script>

<style lang='scss' scoped>
  @import '../../../sass/variables';

  .vuestic-breadcrumbs {
    height: $breadcrumbs-height;
    display: flex;
    align-items: center;

    .crumb {
      &.disabled {
        pointer-events: none;
      }
      &:first-child::before {
        display: none;
      }

      &::before {
        padding: 0 10px;
        display: inline-block;
        content: $breadcrumbs-arrow-content;
        vertical-align: middle;
        color: $brand-primary;
        font-size: $breadcrumbs-arrow-font;
        font-family: FontAwesome;
      }
    }

    a {
      color: $brand-primary;
      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-breadcrumbs/VuesticBreadcrumbs.vue